import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;

export const GroupName = styled.div`
  font-size: 11.5px;
  font-weight: 400;
  max-width: 100%;
  white-space: normal;
  margin-top: 3px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 13.5px;
  white-space: normal;
  max-width: 100%;
  line-height: 15px;
`;

export const ItemName = styled.span`
  font-weight: 300;
  font-size: 12.5px;
`;

export const ContentWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
`;

export const Value = styled.div`
  font-weight: 600;
  font-size: 12px;
  white-space: normal;
`;

export const ContentValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  background-color: #71717146;
  padding: 2px 6px;
  border-radius: 4px;
  min-height: 24px;
`;

interface StatusPropsType {
  $color: string;
}

export const StatusContainer = styled.div<StatusPropsType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 60%;
  min-width: 60px;
  height: 24px;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${(props) => props.$color};
  color: #fff;
`;

export const Status = styled.div`
  font-weight: 600;
  font-size: 12px;
`;

export const Time = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
`;

export const Location = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const LocationText = styled.div`
  width: calc(100% - 15px);
  white-space: normal;
`;

export const PeopleText = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 12px;
  white-space: normal;
`;

export const People = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
`;

export const Avatar = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin: 0 -3px;
  z-index: 10;
  border: 1px solid rgb(234, 234, 234);
`;

export const ExtraAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin: 0 -3px;
  z-index: 10;
  background-color: #717171ff;
  color: white;
`;

export const LinkSection = styled.div`
  max-width: 100%;
  width: fit-content;
`;

export const Link = styled.a`
  display: block;
  color: inherit;
  text-decoration: underline !important;
`;
